import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";

import {
  submitRequest,
  getSecureRequestLinkPageContent,
  ISubmitRequestPayload,
} from "../../api/services/secureDataRequest";
import { IError } from "../../types/common";

export const submitRequestThunk = createAsyncThunk<
  any,
  { requestId: string; payload: ISubmitRequestPayload },
  IError
>("secureDataRequest/submitRequest", async ({ requestId, payload }, { rejectWithValue }) => {
  try {
    const { data } = await submitRequest(requestId, payload);
    return data;
  } catch (err) {
    const error = err as AxiosError<{ message: string }>;
    return rejectWithValue(error.response?.data || { message: error.message });
  }
});

export const getSecureRequestLinkPageContentThunk = createAsyncThunk<any, string, IError>(
  "secureDataRequest/getSecureRequestLinkPageContent",
  async (requestId, { rejectWithValue }) => {
    try {
      const { data } = await getSecureRequestLinkPageContent(requestId);
      return data;
    } catch (err) {
      const error = err as AxiosError<{ message: string }>;
      return rejectWithValue(error.response?.data || { message: error.message });
    }
  }
);
